import { render, staticRenderFns } from "./WapMyAgent.vue?vue&type=template&id=87f7265c&"
import script from "./WapMyAgent.vue?vue&type=script&lang=js&"
export * from "./WapMyAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports